import styled from 'styled-components';

// Typography using ITCGaramondStdBookCondensed
export const BaseDisplay = styled.h1`
	color: ${({ theme }) => theme.colors.black.main};
	font-family: ${({ theme }) => theme.fonts.heading};
	font-style: normal;
	font-weight: 500;
`;

export const DisplayH1 = styled(BaseDisplay).attrs({ as: 'h1' })`
	font-size: 7rem;
	line-height: 110%; /* 96.8px */
	letter-spacing: -0.7px;

	${({ theme }) => theme.mediaQuery.breakpointLg} {
		font-size: 8.8rem;
		letter-spacing: -0.88px;
	}
`;

export const DisplayLarge = styled(BaseDisplay).attrs({ as: 'h2' })`
	font-size: 6rem;
	line-height: 135%; /* 108px */
	letter-spacing: -0.6px;

	${({ theme }) => theme.mediaQuery.breakpointLg} {
		font-size: 8rem;
		letter-spacing: -0.8px;
	}
`;

export const DisplaySmall = styled(BaseDisplay).attrs({ as: 'h2' })`
	font-size: 4rem;
	line-height: 135%; /* 108px */
	letter-spacing: -0.4px;

	${({ theme }) => theme.mediaQuery.breakpointLg} {
		font-size: 6rem;
		letter-spacing: -0.8px;
	}
`;

// Typography using NeueMontreal-Regular
export const BaseSubheading = styled.h2`
	color: ${({ theme }) => theme.colors.black.main};
	font-family: ${({ theme }) => theme.fonts.subheadingRegular};
	font-style: normal;
	font-weight: 400;
`;

export const SubheadingH1 = styled(BaseSubheading).attrs({ as: 'h1' })`
	font-size: 5rem;
	line-height: 135%; /* 67.5px */
	letter-spacing: 0.5px;
`;

export const SubheadingH2 = styled(BaseSubheading)`
	font-size: 4.4rem;
	line-height: 125%; /* 55px */
	letter-spacing: 0.44px;
`;

export const SmallSubheadingH2 = styled(BaseSubheading)`
	font-size: 3.6rem;
	line-height: 48px; /* 133.333% */
	letter-spacing: 0.36px;
`;

export const SubheadingH3 = styled(SmallSubheadingH2).attrs({ as: 'h3' })``;

export const SmallSubheadingH3 = styled(BaseSubheading).attrs({ as: 'h3' })`
	font-size: 2.8rem;
	line-height: 125%; /* 35px */
	letter-spacing: 0.28px;
`;

export const SubheadingH4 = styled(SmallSubheadingH3).attrs({ as: 'h4' })``;

export const SmallSubheadingH4 = styled(SmallSubheadingH3).attrs({
	as: 'h4',
})`
	font-size: 2rem;
	line-height: 100%;
	letter-spacing: 0.2px;
`;

export const CardHeading = styled(BaseSubheading).attrs({ as: 'h4' })`
	font-size: 2.2rem;
	line-height: 125%;
	letter-spacing: 0.22px;
`;

export const StatHeader = styled(BaseSubheading).attrs({ as: 'h4' })`
	font-size: 4rem;
	line-height: normal;
	letter-spacing: 0.4px;
`;

// Typography using NeueMontreal-Medium

export const BaseSmallHeading = styled.p`
	color: ${({ theme }) => theme.colors.black.main};
	font-family: ${({ theme }) => theme.fonts.subheadingMedium};
	font-style: normal;
	font-weight: 500;
`;

export const BaseSmallHeadingSm = styled(BaseSmallHeading)`
	font-size: 1.6rem;
	line-height: 100%; /* 16px */
`;

export const BaseSmallHeadingLg = styled(BaseSmallHeading)`
	font-size: 2rem;
	line-height: 125%; /* 27.5px */
`;

// Typography that use SpeziaSemiMono_600, Courier New, monospace
export const BaseCallout = styled.span`
	color: ${({ theme }) => theme.colors.black.main};
	font-family: ${({ theme }) => theme.fonts.callout600};
	font-style: normal;
	font-weight: 600;
	line-height: 100%; /* 12px */
	text-transform: uppercase;
`;

export const CalloutXs = styled(BaseCallout)`
	font-size: 1.2rem;
	line-height: 125%; /* 15px */
	letter-spacing: 0.6px;
`;

export const CalloutSm = styled(BaseCallout)`
	font-size: 1.4rem;
	line-height: 100%; /* 14px */
	letter-spacing: 0.7px;
`;

export const CalloutMd = styled(BaseCallout)`
	font-size: 1.6rem;
	letter-spacing: 0.8px;
`;

export const CalloutLg = styled(BaseCallout)`
	font-size: 2rem;
	letter-spacing: 1px;
`;

export const SectionOverline = styled(CalloutXs)`
	text-wrap: balance;
	border-radius: 100px;
	background: ${props => props.theme.colors.cream.dark};
	width: fit-content;
	padding: 8px 1.4rem;
	display: block;
`;

export const BodyText = styled.span`
	display: block;
	color: ${({ theme }) => theme.colors.black.main};
	font-family: ${({ theme }) => theme.fonts.body};
	font-weight: 400;
	font-style: normal;
`;

export const BodyText14 = styled(BodyText).attrs({ as: 'p' })`
	font-size: 1.4rem;
	line-height: 24px; /* 175% */
	letter-spacing: 0.14px;
`;

export const BodyText16 = styled(BodyText).attrs({ as: 'p' })`
	font-size: 1.6rem;
	line-height: 28px; /* 175% */
	letter-spacing: 0.16px;
`;

export const BodyText18 = styled(BodyText).attrs({ as: 'p' })`
	font-size: 1.8rem;
	line-height: 32px; /* 177.778% */
	letter-spacing: 0.18px;
`;

export const BodyText20 = styled(BodyText).attrs({ as: 'p' })`
	font-size: 2rem;
	line-height: 36px; /* 180% */
	letter-spacing: 0.2px;
`;

export const BodySmall = styled.p`
	font-family: ${props => props.theme.fonts.body};
	font-size: 1.4rem;
`;

export const SmallTextCallout = styled.p`
	color: ${({ theme }) => theme.colors.black.main};
	font-family: ${props => props.theme.fonts.subheadingMedium};
	font-size: 1.6rem;
	font-style: normal;
	font-weight: 500;
	line-height: 100%; /* 16px */
	letter-spacing: 0.16px;
`;
